import React from 'react'
import { Link } from "react-router-dom"
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  // Checkbox
} from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'

const ChangePass = () => {
  const { updatePass } = useAuth()

  const onFinish = (values) => {
    updatePass(values.password, '/')
    console.log('Success:', values)
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Row justify="center">
      <Col span={24} lg={{ span: 7 }}>
        <div className="form-container">
          <div className="form-header">
            <h1>Change Password</h1>
            <p>Update your account password</p>
          </div>
          <Form
            name="change_pass"
            size="large"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            {/* <Form.Item
              name="oldPassword"
              rules={[{ required: true, message: 'Old Password is reuired!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Old Password"
              />
            </Form.Item> */}
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Password is reuired!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item
              name="confirm"
              // label="Confirm Password"
              dependencies={['password']}
              // hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve()
                    }
                    return Promise.reject(new Error('Password and Confirm passwords does not match!'))
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Confirm Password"
              />
            </Form.Item>
            <Form.Item className="mt-2">
              <Button type="primary" htmlType="submit" size="large" className="px-4">
                Update Password
              </Button>
              <span className="form-link-right ant-btn ant-btn-link ant-btn-lg">
                <Link to="/">Go Back to Dashboard</Link>
              </span>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  )
}

export default ChangePass
